import { Injectable, inject } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GovernmentMonitorModel } from '../../cmg-1003/models';
import { SessionStore } from '../../core/state';
import { iStoreActions } from '../core/store-actions.interface';

export interface Cmg1003GmiState extends EntityState<GovernmentMonitorModel, number> {
  selectedId: string;
}

function createInitialState(): GovernmentMonitorModel {
  return <GovernmentMonitorModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-gmi-store', idKey: 'borrowerId' })
export class Cmg1003GmiStore extends EntityStore<Cmg1003GmiState> implements iStoreActions<Cmg1003GmiState> {
  private readonly _sessionStore = inject(SessionStore);

  private _initValue: GovernmentMonitorModel[] = [];
  constructor() {
    super(createInitialState());
  }

  override akitaPreAddEntity(gmi: GovernmentMonitorModel): GovernmentMonitorModel {
    this._initValue.push(JSON.parse(JSON.stringify(gmi)));
    return gmi;
  }

  override akitaPreUpdateEntity(_: Readonly<GovernmentMonitorModel>, nextEntity: any): GovernmentMonitorModel {
    this._sessionStore.update({ lastUpdatedDateTime: Date.now() });
    return nextEntity;
  }

  get initialValue() {
    return this._initValue;
  }
}
